import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	portalNotice: {
		id: 'project-settings-apps.issue-type-page.field-associated.field-configuration.approvals-data.portal-notice',
		defaultMessage: 'Approval information will be shown on the portal.',
		description:
			'Label below the approval cards to show the user that approvals are visible on the portal',
	},
});
